import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const NoteFromSara = () => (
  <Box sx={{ bgcolor: 'custom.beige', py: { xs: 4, md: 6 }, px: { xs: 1, md: 0 } }}>
    <Paper elevation={2} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2, bgcolor: 'white', maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h2" sx={{ color: 'text.main', mb: 2, textAlign: 'center', fontFamily: 'Just Another Hand' }}>
        A note from me to you 🤍
      </Typography>
      <Typography sx={{ color: 'text.secondary', mb: 2, textAlign: 'center', fontSize: { xs: 16, md: 18 } }}>
        If you’ve been feeling like you’re “not yourself” lately…<br/>
        Please know: you’re not failing.<br/>
        You’re being called back to yourself.<br/>
        And CYJ was created for that return.
      </Typography>
    </Paper>
  </Box>
);

export default NoteFromSara;
